/**
 * Wraps around a default React context value, throwing an error if any
 * undefined properties are accessed
 *
 * @param base - The default React context value
 * @param name - The name of the context
 */
export function missingProviderProxy<T extends object>(base: T, name: string) {
  return new Proxy(base, {
    get: (target, propertyKey, receiver) => {
      if (Reflect.has(target, propertyKey)) {
        return Reflect.get(target, propertyKey, receiver)
      }
      throw new Error(`Cannot call use${name} outside of a ${name}Provider`)
    },
  }) as T
}
